const selectors = {
  userCentrics: ".oembed-element__usercentrics.provider-vimeo",
  embed: ".oembed-element__embed.provider-vimeo",
  primaryButton: '.ubbm-button.ubbm-button--primary.provider-youtube',
  youtubeProvider: '.oembed-element__usercentrics.provider-youtube',
};
const serviceId = 'BJz7qNsdj-7';

const toggleElementVisibility = (elements, isVisible) => {
  elements.forEach(el => el.classList.toggle('d-none', !isVisible));
};

const manageVimeoEmbed = (isactive) => {

  const userCentrics = document.querySelectorAll(selectors.userCentrics);
  const embeds = document.querySelectorAll(selectors.embed);

  console.log('manageVimeoEmbed', isactive, userCentrics, embeds);

  if (isactive) {
    toggleElementVisibility(userCentrics, !isactive);
    toggleElementVisibility(embeds, isactive);
    embeds.forEach(element2 => {
      const source = element2.querySelector('iframe');
      source.src = source.getAttribute('data-src');
    });
  }else {
    toggleElementVisibility(userCentrics, isactive);
    toggleElementVisibility(embeds, !isactive);
  }
};

const checkConsentStatus = (data, id) =>
  data.some(item => item.id === id && item.consent.status);

const checkConsentAndManageVimeoEmbed = () => {
  console.log('load; checkConsentAndManageVimeoEmbed');
  const serviceData = window.UC_UI.getServicesBaseInfo();
  manageVimeoEmbed(checkConsentStatus(serviceData, serviceId));
};

const setupYoutubeConsentButtons = () => {
  const buttons = document.querySelectorAll(selectors.primaryButton);
  buttons.forEach(button => {
    if (button.closest(selectors.youtubeProvider)) {
      button.addEventListener('click', () => {
        window.UC_UI.acceptService(serviceId);
        checkConsentAndManageVimeoEmbed();
      });
    }
  });
};

window.addEventListener('UC_UI_INITIALIZED', checkConsentAndManageVimeoEmbed);
window.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    setupYoutubeConsentButtons();
  }, 0);
});
